/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ViewInputs */

const en_view = /** @type {(inputs: ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

const fr_view = /** @type {(inputs: ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affichage`)
};

const de_view = /** @type {(inputs: ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicht`)
};

const it_view = /** @type {(inputs: ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizzazione`)
};

const ru_view = /** @type {(inputs: ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вид`)
};

const es_view = /** @type {(inputs: ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista`)
};

const zh_cn2_view = /** @type {(inputs: ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`看法`)
};

const ja_view = /** @type {(inputs: ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビュー`)
};

const hi_view = /** @type {(inputs: ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देखना`)
};

const pt_pt2_view = /** @type {(inputs: ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizar`)
};

/**
* | output |
* | --- |
* | "View" |
*
* @param {ViewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const view = /** @type {((inputs?: ViewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ViewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_view(inputs)
	if (locale === "de") return de_view(inputs)
	if (locale === "it") return it_view(inputs)
	if (locale === "ru") return ru_view(inputs)
	if (locale === "es") return es_view(inputs)
	if (locale === "zh-CN") return zh_cn2_view(inputs)
	if (locale === "ja") return ja_view(inputs)
	if (locale === "hi") return hi_view(inputs)
	if (locale === "pt-PT") return pt_pt2_view(inputs)
	return en_view(inputs)
});